import React, { useState } from "react";
import { isKariBday } from "../utils/dateUtils";
import WelcomeModal from "./WelcomeModal";

const BDAY_MODAL_KEY = "ks_bday_modal_seen";

const BirthdayBanner = () => {
  const [showModal, setShowModal] = useState(false);
  const [ripples, setRipples] = useState([]);

  if (!isKariBday()) return null;

  const handleClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const id = Date.now();
    setRipples((r) => [...r, { x, y, id }]);
    setTimeout(() => setRipples((r) => r.filter((rip) => rip.id !== id)), 550);
    setTimeout(() => setShowModal(true), 200);
  };

  const handleClose = () => {
    const today = new Date().toISOString().slice(0, 10);
    localStorage.setItem(BDAY_MODAL_KEY, today);
    setShowModal(false);
  };

  return (
    <>
      <style>{`
        @keyframes bdayGlow {
          0%, 100% { box-shadow: 0 2px 10px rgba(244,114,182,0.35); }
          50%       { box-shadow: 0 2px 20px rgba(244,114,182,0.7); }
        }
        @keyframes bdayRipple {
          to { transform: scale(4); opacity: 0; }
        }
        @keyframes bdayFloat {
          0%, 100% { transform: translateY(0px); }
          50%       { transform: translateY(-3px); }
        }
        .bday-ripple-btn { position: relative; overflow: hidden; }
        .bday-ripple-btn .bday-ripple {
          position: absolute;
          border-radius: 50%;
          width: 80px; height: 80px;
          margin-top: -40px; margin-left: -40px;
          background: rgba(255,255,255,0.3);
          transform: scale(0);
          animation: bdayRipple 0.5s linear;
          pointer-events: none;
        }
        .bday-glow { animation: bdayGlow 2s ease-in-out infinite; }
        .bday-float { animation: bdayFloat 2s ease-in-out infinite; }
      `}</style>

      <button
        onClick={handleClick}
        className="bday-ripple-btn bday-glow w-full flex items-center gap-3 px-4 py-2 border-b border-pink-200/30 font-quicksand"
        style={{
          background: "linear-gradient(135deg, #ffe0f0, #f8e1ff, #ffe0f0)",
        }}
      >
        {ripples.map(({ x, y, id }) => (
          <span key={id} className="bday-ripple" style={{ left: x, top: y }} />
        ))}

        <span className="bday-float" style={{ fontSize: "18px" }}>
          🎂
        </span>

        <div className="text-left flex-1">
          <p
            className="font-bold text-sm leading-tight"
            style={{ color: "#b06ab3" }}
          >
            ¡Feliz cumpleaños, Kari! 🎉
          </p>
        </div>

        <span style={{ fontSize: "16px" }}>🩷</span>
      </button>

      {showModal && <WelcomeModal onClose={handleClose} />}
    </>
  );
};

export default BirthdayBanner;
